import * as React from "react";
import { Polygon } from "@react-google-maps/api";
import type { Zone } from "../../types";
const ZonePolygon = React.memo(function ZonePolygon({
  zone,
  active,
  onClick,
}: {
  zone: Zone;
  active: boolean;
  onClick: (z: Zone, e: google.maps.MapMouseEvent) => void;
}) {
  const paths = React.useMemo(() => zone.polygon, [zone.id]);

  const options = React.useMemo<google.maps.PolygonOptions>(
    () => ({
      fillColor: "#0078C7",
      fillOpacity: active ? 0.5 : 0.2,
      strokeColor: "#0078C7",
      strokeWeight: active ? 4 : 2,
      zIndex: active ? 2 : 1,
      clickable: true,
    }),
    [active, zone.id]
  );

  const handleClick = React.useCallback(
    (e: google.maps.MapMouseEvent) => onClick(zone, e),
    [onClick, zone]
  );

  return <Polygon paths={paths} options={options} onClick={handleClick} />;
});

export default ZonePolygon;
